import { Card } from "antd";
import React from "react";
import { Pie } from "@ant-design/plots";
import { useSelector } from "react-redux";

const ProjectsPieChart = () => {
  const { projectsGraphData } = useSelector((state) => state.projectsState);

  const config = {
    data: [
      {
        type: "COMPLETED PROJECTS",
        value: projectsGraphData.runningProjectsGraph?.completedProjects,
      },
      {
        type: "ACTIVE PROJECTS",
        value: projectsGraphData.runningProjectsGraph?.runningProjects,
      },
    ],
    angleField: "value",
    colorField: "type",
    label: {
      text: "value",
      style: {
        fontWeight: "bold",
      },
    },
    radius: 1,
    legend: {
      color: {
        title: false,
        position: "top",
        rowPadding: 5,
      },
    },
  };
  return (
    <Card
      title={`${projectsGraphData.runningProjectsGraph?.totalProjects} Total Projects`}
      Total
      Projects
    >
      <Pie {...config} />
    </Card>
  );
};

export default ProjectsPieChart;
